export const transformerTypes = ["Ground-mounted Transformer", "Pole-mounted Transformer"];

export const propertyTypes = [
  "Domestic Property",
  "Small Commercial Property",
  "Large Commercial Property",
  "Industrial Property",
];

export const lctTypes = ["Generator", "Heat Pump", "EV Chargepoint"];

export const nodeTypes = ["Node", "Service End Node"];

export const annotationTypes = ["Sticky Note", "Rectangle", "Circle", "Arrow"];

export const conductorTypes = [
  "Mains Overhead Line",
  "Mains Underground Cable",
  "Service Overhead Line",
  "Service Underground Cable",
];

export const groupedTypes: GroupedTypes = {
  properties: propertyTypes,
  transformers: transformerTypes,
  lct: lctTypes,
  conductors: conductorTypes,
  nodes: nodeTypes,
  annotations: annotationTypes,
};

export interface GroupedTypes {
  [key: string]: string[];
  properties: string[];
  transformers: string[];
  lct: string[];
  conductors: string[];
  nodes: string[];
  annotations: string[];
}

export enum DemandChangeTypeEnum {
  Absolute = "Absolute",
  Relative = "Relative",
}
